import { createStore } from 'vuex'
import modules from './modules'
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: modules,
  plugins: [
    createPersistedState({
      key: 'ui', // Ключ для localStorage
      paths: ['ui'], // Указываем только тот модуль, который нужно сохранить
    }),
  ],
})
